<template>
  <div class = "predict">
    <el-form 
    ref="ruleForm" 
    :inline="true" 
    :model="ruleForm" 
    :rules="rules" 
    label-width="100px" 
    class="demo-ruleForm"
    >
      <el-form-item label="E-mail">
        <el-input v-model="ruleForm.mail"></el-input>
      </el-form-item>
      <br>
      <el-form-item label="pwd">
        <el-input v-model="ruleForm.pwd"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >Update</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "predict",
  data() {
    return {
      ruleForm: {
        mail: "",
        pwd: "",
      },
      rules: {
        mail: [
          { required: true, message: "Please enter your mail", trigger: "blur" },
        ],
        pwd: [
          { required: true, message: "Please enter your pwd", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // submitForm(formName) {
    //   this.$refs[formName].validate((valid) => {
    //     if (valid) {
    //       this.login();
    //     } else {
    //       console.log("error submit!!");
    //       return false;
    //     }
    //   });
    // },
    onSubmit() {
      this.$http({
        url: "/api/update/sendmail",
        methods: "get",
        params: this.ruleForm,
      }).then((data) => {
        console.log(data);
        this.$message('successfully');
        // this.$router.back();
      });
    },
  },
  mounted(){
      self.$http({
        url: "/api/rdkit/querySendMailById",
        methods: "get",
        params: {
          id: self.$route.query.id
        },
      }).then((res) => {
          self.upForm = res.data.data
      });
  }
};
</script>

<style scoped>
  .page-warp {
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .down-load {
    display: flex;
    justify-content: flex-end;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>